<div class="myevents-page" [@pageLoadAnimation]>
  <app-account-status-banner></app-account-status-banner>

  <div class="myevents-content animated-item" [@pageLoadAnimation]>
    <ng-template [ngIf]="!isLoading" [@pageLoadAnimation]>

      <!-- Page Header -->
      <div class="page-header animated-item" [@pageLoadAnimation]>
        <div class="page-heading">
          <h1 class="page-title">My events
            
          </h1>
          <p class="page-subtitle">Manage and share your photography collections</p>
        </div>

        <div *ngIf="isMobile" class="mobile-create-btn">
          <button type="button" (click)="openCreateEvent()" class="picaggo-btn-primary icon-only"
            [class.disabled-button]="isAnyLive" [disabled]="isAnyLive">
            <app-icon name="plus" width="18" height="18"></app-icon>
          </button>
        </div>
      </div>

      <!-- Toolbar: search + filters + view toggles -->
      <div class="toolbar animated-item" [@pageLoadAnimation]>
        <div class="search-bar">
          <span class="search-icon" (click)="onSearch(searchTerm)">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z"
                stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <input type="text" name="search" [(ngModel)]="searchTerm" (keydown.enter)="onSearch(searchTerm)"
            class="search-input" placeholder="Search by event name or tag" autocomplete="off" />
          <span class="clear-icon" *ngIf="searchTerm" (click)="clearSearch()">
            <app-icon name="close" width="14" height="14"></app-icon>
          </span>
        </div>

        <button type="button" class="filter-btn" [class.active]="showFilterPanel" (click)="toggleFilterPanel()">
          <app-icon name="filter" width="18" height="18"></app-icon>
          <span>Filters</span>
        </button>

        <button *ngIf="!isMobile" type="button" (click)="openCreateEvent()" class="picaggo-btn-primary"
          [class.disabled-button]="isAnyLive" [disabled]="isAnyLive"
          [matTooltip]="isAnyLive ? 'Create Event is disabled while Live Event is running' : ''"
          matTooltipPosition="above">
          <app-icon name="plus" width="16" height="16"></app-icon>
          <span class="padding-left-6">Create Event</span>
        </button>
      </div>

      <!-- Filter panel -->
      <div class="filter-panel animated-item" *ngIf="showFilterPanel" [@pageLoadAnimation]>
        <span class="filter-label">Show</span>
        <button type="button" class="filter-chip" *ngFor="let ownership of ownershipFilterOptions"
          [class.active]="isOwnershipFilterActive(ownership)" (click)="toggleOwnershipFilter(ownership)">
          {{ ownership }}
        </button>
      </div>

      <!-- Empty State — first-time onboarding -->
      <div *ngIf="_eventDetail?.length === 0 && !isSearchActive" class="empty-state onboarding-state animated-item" [@pageLoadAnimation]>
        <h2 class="onboarding-title">Collect every guest photo,<br>automatically</h2>
        <p class="onboarding-subtitle">Create, share, invite — done in a minute.</p>

        <!-- Numbered steps -->
        <div class="onboarding-steps">
          <div class="onboarding-step">
            <div class="step-number">1</div>
            <div class="step-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.8"/>
                <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.8"/>
                <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.8"/>
                <rect x="14" y="14" width="3" height="3" rx="0.5" fill="currentColor"/>
                <rect x="18" y="14" width="3" height="3" rx="0.5" fill="currentColor"/>
                <rect x="14" y="18" width="3" height="3" rx="0.5" fill="currentColor"/>
                <rect x="18" y="18" width="3" height="3" rx="0.5" fill="currentColor"/>
              </svg>
            </div>
            <p class="step-label">Create event</p>
          </div>
          <div class="onboarding-step">
            <div class="step-number">2</div>
            <div class="step-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="7" r="3" stroke="currentColor" stroke-width="1.8"/>
                <path d="M3 20c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                <circle cx="17" cy="7" r="2.5" stroke="currentColor" stroke-width="1.5"/>
                <path d="M21 20c0-2.761-1.791-5-4-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <p class="step-label">Invite guests</p>
          </div>
          <div class="onboarding-step">
            <div class="step-number">3</div>
            <div class="step-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="2" width="12" height="20" rx="2" stroke="currentColor" stroke-width="1.8"/>
                <circle cx="12" cy="18" r="1" fill="currentColor"/>
                <path d="M9 5h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <p class="step-label">Get the app</p>
            <p class="step-sublabel">for Autopilot</p>
          </div>
        </div>

        <!-- CTA -->
        <button *ngIf="!isAnyLive" type="button" (click)="openCreateEvent()" class="picaggo-btn-primary onboarding-cta">
          + Create your first event
        </button>
        <p class="onboarding-hint">Takes under a minute</p>

        <!-- App download banner -->
        <div class="app-download-banner">
          <div class="app-banner-header">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="2" width="12" height="20" rx="2" stroke="#EE4147" stroke-width="1.8"/>
              <circle cx="12" cy="18" r="1" fill="#EE4147"/>
            </svg>
            <div class="app-download-text">
              <strong>Get the app for Autopilot</strong>
              <span>Optional — makes sharing effortless</span>
            </div>
          </div>
          <div class="app-banner-badges">
            <a class="badge-ios" href="https://apps.apple.com/us/app/picaggo/id1527686260" target="_blank" rel="noopener">
              <img src="/assets/icon/app-store-badge.svg" alt="Download on the App Store" />
            </a>
            <a class="badge-android" href="https://play.google.com/store/apps/details?id=application.share.photo.picaggo" target="_blank" rel="noopener">
              <img src="/assets/icon/play-store-badge.svg" alt="Get it on Google Play" />
            </a>
          </div>
        </div>
      </div>

      <!-- Grouped sections -->
      <ng-container *ngIf="!isSearchActive">
        <div class="event-section animated-item" *ngFor="let item of _eventDetail" [@pageLoadAnimation]>
          <div class="section-header">
            <h2 class="section-title">{{ getSectionTitle(item) | titlecase }}</h2>
            <a class="see-all-link" *ngIf="item.events.length >= 5" (click)="getAllEventsByCategory(item.categoryId)">
              See All
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </div>

          <div class="event-grid" *ngIf="getVisibleEvents(item).length; else noMatch">
            <ng-container *ngFor="let event of getVisibleEvents(item)">
              <ng-container
                *ngTemplateOutlet="eventCard; context: { event: event, item: item }"></ng-container>
            </ng-container>
          </div>
          <ng-template #noMatch>
            <p class="no-match-text">No events match the selected filters.</p>
          </ng-template>
        </div>
      </ng-container>

      <!-- Search results -->
      <ng-container *ngIf="isSearchActive">
        <div class="event-section animated-item" [@pageLoadAnimation]>
          <div class="section-header">
            <h2 class="section-title">Search Results</h2>
          </div>

          <div class="event-grid" *ngIf="getVisibleSearchEvents().length; else noResults">
            <ng-container *ngFor="let event of getVisibleSearchEvents()">
              <ng-container
                *ngTemplateOutlet="eventCard; context: { event: event, item: null }"></ng-container>
            </ng-container>
          </div>
          <p class="no-match-text" *ngIf="getVisibleSearchEvents().length && searchIsTruncated() && !searchHasMore">
            Showing the best matches. Add another word to narrow the search.
          </p>
          <ng-template #noResults>
            <p class="no-match-text">No events match "{{ searchTerm }}".</p>
            <button type="button" class="btn btn-link" (click)="clearSearch()">Clear search</button>
          </ng-template>
        </div>
      </ng-container>

    </ng-template>

    <ng-template [ngIf]="moreCategories">
      <div class="stage" style="margin-left: 50%;">
        <div class="dot-flashing"></div>
      </div>
    </ng-template>
  </div>

  <!-- Loading overlay -->
  <div class="overlay1 animated-item" *ngIf="isLoading">
    <span class="loader"></span>
  </div>

  <!-- Page-level confirmation modal for stop event -->
  <app-confirmation-modal *ngIf="showConfirmModal" [confirmMessage]="confirmMessage"
    (confirmed)="onStopConfirmed($event, stopEventId)" [isHomePage]="isHomePage"></app-confirmation-modal>

  <!-- Locked Event Popup -->
  <div class="locked-popup-backdrop" *ngIf="showLockedPopup" (click)="showLockedPopup = false">
    <div class="locked-popup-card" (click)="$event.stopPropagation()">
      <div class="locked-popup-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="#EE4147">
          <path
            d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
        </svg>
      </div>
      <h3 class="locked-popup-title">{{ lockedPopupIsHost ? 'Album' : 'Event Gallery' }} Temporarily Paused</h3>

      <ng-container *ngIf="lockedPopupIsHost">
        <p class="locked-popup-message">Your plan has expired and this album is currently locked. Renew your plan to
          restore access.</p>
        <div class="locked-popup-actions">
          <button class="locked-popup-btn locked-popup-btn--primary" (click)="navigateToRenew()">Renew Plan</button>
          <button class="locked-popup-btn locked-popup-btn--outline" (click)="showLockedPopup = false">Cancel</button>
        </div>
      </ng-container>

      <ng-container *ngIf="!lockedPopupIsHost">
        <p class="locked-popup-message">This Event Gallery is temporarily paused by the host. Please check back later.</p>
        <div class="locked-popup-actions">
          <button class="locked-popup-btn locked-popup-btn--primary" (click)="showLockedPopup = false">Go to
            Home</button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Reusable event card template -->
<ng-template #eventCard let-event="event" let-item="item">
  <div class="event-card animated-item"
    (click)="cardDetail(event.viewer_hash, true, event.restricted == 1 ? true : false, event.start_time, item?.categoryName, event?.default_upload, event?.isHost, event)">
    <div class="card-cover">
      <img class="cover-img" [src]="event?.coverImage || '/assets/images/default_cover.png'" alt="" />

      <div class="event-lock-overlay" *ngIf="(event.locked == 1 || event.locked === true) && event.isHost">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="white">
          <path
            d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
        </svg>
      </div>
      <div class="event-lock-badge" *ngIf="(event.locked == 1 || event.locked === true) && !event.isHost">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="white">
          <path
            d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
        </svg>
      </div>

      <div class="date-pill">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.8" />
          <path d="M3 9H21" stroke="currentColor" stroke-width="1.8" />
          <path d="M8 2.5V5.5M16 2.5V5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
        <span>{{ getEventDate(event) | date: 'd MMM, h:mm a' }}</span>
      </div>

      <button type="button" class="live-stop-btn" *ngIf="getEventStatus(item, event) === 'Live'"
        (click)="stopConfirm($event, event.isHost, event?.eventId)">
        <span class="live-dot"></span>
        <span>{{ displayTimer || 'Live' }}</span>
      </button>

      <div class="avatar-stack">
        <img *ngIf="event?.hostImage && !event.hostImageError" class="host-avatar" [src]="event?.hostImage"
          (error)="onHostImageError(event)" alt="" />
        <div *ngIf="!event?.hostImage || event.hostImageError" class="host-avatar host-avatar-initial">
          {{ event.user_name ? event.user_name.charAt(0) : (event.hostName ? event.hostName.charAt(0) : '?') }}
        </div>
      </div>
    </div>

    <div class="card-body">
      <h3 class="card-title">{{ event?.eventName | titlecase }}</h3>
      <div class="card-meta">
        <span class="photo-count">
          <app-icon name="image" width="16" height="16"></app-icon>
          {{ event.file_count || 0 }}
        </span>
        <span class="status-badge" *ngIf="getEventStatus(item, event) !== 'Published'"
          [ngClass]="'status-' + (getEventStatus(item, event).toLowerCase())">
          {{ getEventStatus(item, event) }}
        </span>
      </div>
    </div>
  </div>
</ng-template>
